module.exports = {"timezone":{"NST":"HNT","NDT":"HAT","AST":"HNA","ADT":"HAA","EST":"HNE","EDT":"HAE","CST":"HNC","CDT":"HAC","MST":"HNR","MDT":"HAR","PST":"HNP","PDT":"HAP","YST":"HNY","YDT":"HAY"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src332225586/src/modules/web/src/js/i18n/french/timezone.fr.i18n.json
// module id = 1237
// module chunks = 0